import { Location } from "@angular/common";
import { Component, HostListener, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs";
import { environment } from "src/environments/environment";
import { UnsubscribeOnDestroy } from "../_helpers/unsubscribe-on-destroy";
import { NotificationReadService } from "../_services/notificacion-read.service";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { TokenStorageService } from "../_services/token-storage.service";
import { UserService } from "../_services/user.service";
import { ClientLoaderService } from "../core/util/client-loader.service";
import { getMenuLabelKey } from "../core/util/menu-i18n.util";
import { NotificationI18nService } from "../core/util/notification-i18n.service";

export interface DataModel {
  menuListado: string;
}

@Component({
  selector: "app-board-admin",
  templateUrl: "./board-admin.component.html",
  styleUrls: ["./board-admin.component.css"],
})
export class BoardAdminComponent extends UnsubscribeOnDestroy implements OnInit {
  API_URL: string = environment.API_URL;
  content: any = [];
  myForm: UntypedFormGroup;
  currentUser: any;
  currentEnv: string;
  totalElements: number = 0;
  getScreenWidth: any;
  numeroComunicacionesPendientes;
  numeroNotificacionesPendientes;
  numeroNotificacionesAutorizaciones;
  totalNotificaciones;
  showDiv = { crear: false, actualizar: false, eliminar: false }
  Listado: any = [];
  miData: any = [];
  menuListado: any = [];
  menuPerfil: any = [];
  seleccionado: string;
  miid;
  TipoFirma: any = [];
  EstadoElaboracion: any = [];
  EstadoDocumento: any = [];
  Origenes: any = [];
  TipoDocumentales: any = [];
  SubTipoDocumentales: any = []
  formData: UntypedFormGroup;
  menuOption: String;
  formVisible: boolean;
  formAsuntoVisible;
  formLibroVisible;
  procVisible: boolean;
  autoVisible: boolean;
  textProcedimientos: string;
  hijosList: any = [];
  menuPadre: any = [];
  selectedOption: any = {};
  environment = environment;
  public reloadComponent: boolean = false;
  /** action de la URL al entrar (las cards llegan con ?action=); no perderlo al limpiar la query. */
  private initialAction: string | null = null;

  constructor(
    private userService: UserService,
    private servicioGeneral: ServicioGeneral,
    private servicioNotificaciones: NotificationReadService,
    private formBuilder: UntypedFormBuilder,
    private token: TokenStorageService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private clientLoader: ClientLoaderService,
    private _notificationI18n: NotificationI18nService
  ) {
    super();
    this.buildForm();
    this.currentEnv = environment.environment;
  }

  public buildForm() {
    this.myForm = this.formBuilder.group({
      opcionesmenu: [null],
    });
  }

  setSelectedOption(valueSelected) {
    this.checkNotificaciones();

    const actionNum = Number(valueSelected?.action);
    const normalized = {
      ...valueSelected,
      action: Number.isNaN(actionNum) ? valueSelected?.action : actionNum,
      labelKey: valueSelected?.labelKey ?? getMenuLabelKey(valueSelected),
    };

    // Perfil incompleto: forzar edición (no dejar action en -1 / Área de usuario).
    if (normalized.action !== 20 && normalized.action !== -1 && this.isProfileIncomplete()) {
      this._notificationI18n.warning('COMMON.PROFILE_INCOMPLETE');
      this.openEditProfile();
      return;
    }

    this.selectedOption = normalized;
  }

  redirectUrl(menu) {
    if (this.isProfileIncomplete()) {
      this._notificationI18n.warning('COMMON.PROFILE_INCOMPLETE');
      this.openEditProfile();
      return;
    }
    window.open('#/' + menu.url);
  }

  private isProfileIncomplete(): boolean {
    const u = this.currentUser;
    return u == null || u.email == null || u.telefono == null;
  }

  private openEditProfile(): void {
    const edit = this.menuListado.find((m) => Number(m.action) === 20);
    this.selectedOption = edit
      ? { ...edit, action: 20, labelKey: getMenuLabelKey({ action: 20 }) }
      : { action: 20, nombre: 'Editar perfil', labelKey: 'MENU.20' };
    this.router.navigate([], { queryParams: { action: 20 }, queryParamsHandling: 'merge' });
  }

  public obtenerContenido() {
    return this.myForm.controls["opcionesmenu"].value;
  }

  public onSubmit(data: DataModel) { }

  ngOnInit(): void {
    // Guardar action antes de tocar la URL (snapshot + hash: useHash a veces deja el ?action solo en location.hash).
    this.initialAction = this.readActionFromUrl();

    this.currentUser = this.token.getUser();
    this.verificarUserRol();
    this.formData = new UntypedFormGroup({
      organo: new UntypedFormControl(),
      tipoFirma: new UntypedFormControl(),
      firmaServidor: new UntypedFormControl(),
      origen: new UntypedFormControl(),
      estadoElaboracion: new UntypedFormControl(),
      tipoDocumental: new UntypedFormControl(),
    });

    this.getMenuLateralList();
    this.checkNotificaciones();
    this.getScreenWidth = window.innerWidth;
    this.servicioGeneral.getCaducidadesObs();
  }

  /** Lee ?action= del router o del hash (#/perfil?action=3). */
  private readActionFromUrl(): string | null {
    const fromRoute = this.route.snapshot.queryParamMap.get('action');
    if (fromRoute != null && fromRoute !== '') {
      return fromRoute;
    }
    const hash = window.location.hash || '';
    const q = hash.indexOf('?');
    if (q < 0) {
      return null;
    }
    return new URLSearchParams(hash.substring(q + 1)).get('action');
  }

  checkNotificaciones() {
    this.servicioNotificaciones.getAlertMap()
      .pipe(takeUntil(this.destroy$))
      .subscribe((map: Map<string, string>) => {
        this.numeroNotificacionesPendientes = map.get('notificaciones');
        this.numeroComunicacionesPendientes = map.get('comunicaciones');
        this.numeroNotificacionesAutorizaciones = map.get('autorizaciones');
        this.totalNotificaciones = map.get('totales');
      });
  }

  removeParamFromURL(): void {
    // Quitar ?action= sin destruir el estado ya aplicado en selectedOption.
    this.location.replaceState('/perfil');
  }

  getMenuLateralList() {
    return this.servicioGeneral.getMenuLateralList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const menus = data['Menu'] || [];
        this.menuListado = this.filterMenuForClient(menus);

        const applyAction = (action: string | null | undefined) => {
          if (this.isProfileIncomplete()) {
            this.openEditProfile();
            return;
          }

          if (action == null || action === '') {
            this.selectedOption = { action: -1, nombre: 'Home', labelKey: 'MENU.HOME' };
            return;
          }

          if (action === '20') {
            this.openEditProfile();
            return;
          }

          const actionNum = Number(action);
          if (Number.isNaN(actionNum)) {
            this.selectedOption = { action: -1, nombre: 'Home', labelKey: 'MENU.HOME' };
            return;
          }

          const menu = this.menuListado.find((mL) => Number(mL.action) === actionNum);
          if (menu) {
            this.setSelectedOption(menu);
            return;
          }

          for (let i = 0; i < this.menuListado.length; i++) {
            const parent = this.menuListado[i];
            const submenu = parent.listadoHijos?.find((smL) => Number(smL.action) === actionNum);
            if (submenu) {
              parent.isCollapsed = true;
              parent.isRowActive = true;
              this.setSelectedOption(submenu);
              return;
            }
          }

          // Deep link / cards: abrir la vista aunque el ítem no venga en el árbol del menú
          this.setSelectedOption({
            action: actionNum,
            nombre: this.fallbackActionName(actionNum),
            labelKey: getMenuLabelKey({ action: actionNum }),
            rol: null,
          });
        };

        const actionToApply = this.initialAction ?? this.readActionFromUrl();
        applyAction(actionToApply);
        this.initialAction = null;
        this.removeParamFromURL();

        this.route.queryParams
          .pipe(takeUntil(this.destroy$))
          .subscribe((params) => {
            if (params['action']) {
              applyAction(params['action']);
            }
          });
      });
  }

  private fallbackActionName(action: number): string {
    switch (action) {
      case 3: return 'Crear un nuevo trámite';
      case 30: return 'Mis trámites';
      case 32: return 'Comunicaciones';
      case 33: return 'Notificaciones Aceptadas';
      case 34: return 'Notificaciones Pendientes';
      default: return 'Área de usuario';
    }
  }

  changeCollapse(menu) {
    menu.isCollapsed = !menu.isCollapsed;
    menu.isRowActive = menu.isCollapsed;
  }

  esrol: any = [];
  verificarUserRol() {
    this.esrol = this.currentUser.rol;
    return this.esrol;
  }

  scrollIf(isDown) {
    if (isDown) {
      window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
  }

  /**
   * GMU: oculta Trámites (action 10) y Autorizaciones pendientes (action 35).
   * EMVS: menú completo.
   */
  private filterMenuForClient(menus: any[]): any[] {
    const showTramites = this.clientLoader.hasTramitesCatalogSync();
    const showAutorizaciones = this.clientLoader.hasAutorizacionesPendientesSync();

    return menus
      .filter((m) => showTramites || m.action !== 10)
      .map((m) => this.enrichMenuItem(m, showAutorizaciones));
  }

  private enrichMenuItem(menu: any, showAutorizaciones: boolean): any {
    const hijos = menu.listadoHijos?.length
      ? (showAutorizaciones
        ? menu.listadoHijos
        : menu.listadoHijos.filter((h) => h.action !== 35))
        .map((h) => this.enrichMenuItem(h, showAutorizaciones))
      : menu.listadoHijos ?? [];

    return {
      ...menu,
      listadoHijos: hijos,
      labelKey: getMenuLabelKey(menu),
      isCollapsed: menu.isCollapsed ?? false,
      isRowActive: menu.isRowActive ?? false,
    };
  }

  showMenu(submenu, currentUser) {
    if (
      !this.clientLoader.hasAutorizacionesPendientesSync() &&
      submenu?.action === 35
    ) {
      return false;
    }
    let canShow = false;
    if (submenu.rol != null && currentUser.rol.includes(submenu.rol['id'])) {
      canShow = true;
    }
    return canShow;
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
  }

  getFirstLetter(nombre: string) {
    return nombre ? nombre.charAt(0).toUpperCase() : '';
  }

  /** Iconos de panel desde assets del front (evita depender del back /emvs/). */
  menuIconSrc(icono: string): string | null {
    if (!icono) {
      return null;
    }
    // Rutas BD tipo /emvs/panel_emvs/entrada_emvs_small.svg → assets del front
    const cleaned = icono.replace(/^\/+/, '');
    if (cleaned.startsWith('emvs/panel_emvs/')) {
      return 'assets/' + cleaned;
    }
    if (cleaned.startsWith('emvs/panel/')) {
      // Variante genérica: existe en assets/panel/
      const file = cleaned.substring('emvs/panel/'.length);
      return 'assets/panel/' + file;
    }
    const path = icono.toLowerCase();
    if (path.includes('entrada_emvs') || path.includes('panel_emvs/entrada')) {
      return 'assets/emvs/panel_emvs/entrada_emvs_small.svg';
    }
    if (path.includes('entrada')) {
      return 'assets/panel/entrada_small.svg';
    }
    if (path.includes('tramites_emvs') || path.includes('tramite_emvs')) {
      return 'assets/emvs/panel_emvs/tramites_emvs_small.svg';
    }
    if (path.includes('tramites') || path.includes('tramite')) {
      return 'assets/panel/tramites_small.svg';
    }
    if (path.includes('notificacion_emvs')) {
      return 'assets/emvs/panel_emvs/notificacion_emvs_small.svg';
    }
    if (path.includes('notificacion')) {
      return 'assets/panel/notificacion_small.svg';
    }
    if (path.includes('pago')) {
      return 'assets/panel/pago_small.svg';
    }
    return this.API_URL + icono;
  }
}